import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch, Link } from 'react-router-dom'
import { isMobile } from 'react-device-detect'
import './App.css';
import Home from './Home'
import {
  Alert,
  Button, Icon, Layout, Steps, Table
} from "antd";
import injectSheet from 'react-jss'
import Scrollbars from 'react-custom-scrollbars'
import md from 'markdown-it'
import mk from 'markdown-it-katex'
import scripts from 'script-tags'
import Parser from 'html-react-parser'
import Titanium from './components/titanium'
import PhaseSwitcher from './components/phaseSwitcher'
import SVG from './components/svg'
import Animation from './components/animation'
import IFrame from './components/iframe'
import qs from 'qs'
import Cryptr from 'cryptr'

import UNSWLogo from "./img/unsw_neg.png";

const { Content, Footer, Sider } = Layout;
const { Step } = Steps;
const mdk = md({ html: true, xhtmlOut: true, typographer: true });

let charts = [];
const crypter = new Cryptr('very_much_secret_key');
let parsed = qs.parse(window.location.search.substr(1));
let site_course = window.location.host.split(".")[0];

if (!parsed.zid) {
  parsed.zid = 'Guest'
}

if (!parsed.courseid) {
  parsed.courseid = 'N/A'
}

if (!parsed.name) {
  parsed.name = 'N/A'
}

const valid_sites = ["mats2003"]
site_course = valid_sites.includes(site_course) ? site_course : 'mats2003';
console.log(site_course);
class App extends Component {
  constructor(props) {
    super(props);
    this.state = { modules: null };
  }

  setQuizParams() {
    if (!localStorage.getItem('zid') && parsed.zid) localStorage.setItem('zid', crypter.encrypt(parsed.zid));
    if (!localStorage.getItem('courseid') && parsed.courseid) localStorage.setItem('courseid', crypter.encrypt(parsed.courseid));
    if (!localStorage.getItem('name') && parsed.name) localStorage.setItem('name', crypter.encrypt(parsed.name));
  }


  componentDidMount() {
    this.setQuizParams();
    mdk.use(mk);
    fetch(`/pages/modules.json`).then((response) => {
      return (response.json());
    }).then((json) => {
      let modules = [];
      let curr_group;
      let list = [];
      let glossary = [];
      json.modules.forEach((module) => {
        if (module.course.includes(site_course)) {
          if (curr_group !== module.group) {
            if (list.length) {
              modules.push({ group_name: list[0].group, modules: list })
            }
            list = [];
            curr_group = module.group;
          }
          list.push(module);
          // push to glossary
          fetch(`/pages/${module.folder}/glossary.json`).then((response) => {
            return response.json();
          }).then((json) => {
            glossary.push({ key: module.folder, glossary: json });
            this.setState({ glossary });
          });
          return null;
        }
      });
      if (list.length) {
        modules.push({ group_name: list[0].group, modules: list });
      }
      this.setState({ modules });
    });
  }

  render() {
    return (
      <Router>
        <div className="App">
          <Switch>
            <Route path="/:id/:page/"
              render={(props) => <Viewer {...props} {...this.props} glossary={this.state.glossary} />} />
            <Route path="/:id/"
              render={(props) => <Viewer {...props} {...this.props} glossary={this.state.glossary} />} />
            <Route path="/" render={(props) => <Home {...props} modules={this.state.modules} />} />
          </Switch>
        </div>
      </Router>
    );
  }
}

class Viewer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      step: this.props.match.params.page ? Number(this.props.match.params.page) - 1 : 0,
      html: {}, js: {},
      loaded: false,
      collapsed: isMobile
    };
  }

  componentDidMount() {
    const step = this.props.match.params.page ? this.props.match.params.page - 1 : 0;
    fetch(`/pages/${this.props.match.params.id}/pages.json`).then((response) => {
      return response.json();
    }).then((json) => {
      const filtered_pages = json.pages.filter(page => page.course.includes(site_course));
      fetch(`/pages/${this.props.match.params.id}/glossary.json`).then((glossary) => {
        return glossary.json()
      }).then ((glossary) => {
        if(glossary.length >0){
          filtered_pages.push({ title: "Glossary" });
        }
      })
      
      this.setState({ title: json.title, pages: filtered_pages });
    }).then(() => {
      this.changePage(step, true)
    });
  }

  componentDidUpdate() {
    const step = this.props.match.params.page ? this.props.match.params.page - 1 : 0;
    if (this.state.pages) document.title = this.props.match.params.id !== null ? `${this.state.title} - ${this.state.pages[step].title}` : "MATS2003";
    if (step === this.state.step && !this.state.loaded && this.state.js[this.state.step] && this.state.js[this.state.step].length) {
      eval(this.state.js[this.state.step]);
      this.setState({ loaded: true });
    }
  }

  scroll_steps(target, acceleration) {
    const scrollbar = this.refs.steps_scrollbar;
    if (!scrollbar) return;
    const v = (Math.abs(scrollbar.getValues().scrollTop - target) >= Math.abs(acceleration)) ? scrollbar.getValues().scrollTop + acceleration : target;
    scrollbar.scrollTop(v);
    if (v !== target && v >= 0)
      setTimeout(() => this.scroll_steps(target, acceleration * 1.2), 10);
  }

  changePage(i, initial) {
    charts.forEach((chart) => {
      chart.detach()
    });
    charts = [];
    const is_markdown = this.state.pages[i].md;
    const format = is_markdown ? 'md' : 'html';
    if (!this.state.html[i]) {
      fetch(`/pages/${this.props.match.params.id}/${this.state.pages[i][format]}.${format}`)
        .then((response) => {
          return response.text();
        }
        ).then((text) => {
          const html = is_markdown ? mdk.render(text) : text;
          const js = scripts(html);
          this.setState({
            step: i,
            loaded: false,
            html: { ...this.state.html[i], [i]: is_markdown ? mdk.render(text) : text },
            js: { ...this.state.js, [i]: js.length && js[0].text }
          });
          this.refs.page_scrollbar.scrollTop();
          const scrollbar = this.refs.steps_scrollbar;
          const target = Math.max(0, (i) / this.state.pages.length * scrollbar.getScrollHeight() - 0.5 * scrollbar.getClientHeight());
          this.setState({ steps_scroll_target: target });
          this.scroll_steps(target, scrollbar.getValues().scrollTop < target ? 2.0 : -2.0);
          if (!initial) this.props.history.push(`/${this.props.match.params.id}/${i + 1}`);
        })
    }
    else {
      this.refs.page_scrollbar.scrollTop();
      const scrollbar = this.refs.steps_scrollbar;
      const target = Math.max(0, (i) / this.state.pages.length * scrollbar.getScrollHeight() - 0.5 * scrollbar.getClientHeight());
      this.setState({ steps_scroll_target: target, step: i, loaded: false });
      this.scroll_steps(target, scrollbar.getValues().scrollTop < target ? 2.0 : -2.0);
      if (!initial) this.props.history.push(`/${this.props.match.params.id}/${i + 1}`);
    }
  }

  onCollapse = () => {
    this.setState({ collapsed: !this.state.collapsed })
  };

  render() {
    // load and sort glossary
    let glossary = [];

    if (this.props.glossary) {

      this.props.glossary.sort((a, b) => a.key.localeCompare(b.key));
      for (const item of this.props.glossary) {
        const curr = item.key === this.props.match.params.id;
        for (const entry of item.glossary) {
          glossary.push({ ...entry, curr });
        }

        if (curr) break;
      }
    }
    glossary.sort((a, b) => a.term.localeCompare(b.term));
    const step = this.props.match.params.page ? this.props.match.params.page - 1 : 0;
    if (!this.state.pages) return null;
    return (
      <Layout style={{ background: 'transparent' }}>
        <Sider className="sider" collapsed={this.state.collapsed} collapsible onCollapse={this.onCollapse}
          collapsedWidth={48} width={256}
          trigger={null}
          style={{
            background: 'transparent',
            position: isMobile ? 'relative' : 'relative',
            zIndex: 1,
            height: "100%",
            overflowY: 'auto',
            color: 'white',
            overflow: 'hidden',
          }}>
          
          {this.state.pages &&
            <div style={{ height: '100%', display: 'flex', flexFlow: 'column', alignItems: 'center' }}>
            <img alt="UNSW Logo" src={UNSWLogo} style={{ width: "65%", marginTop: 6 }}/>
              <div style={{
                display: 'flex',
                alignItems: 'baseline',
                justifyContent: 'flex-start',
                width: "100%"
              }}>
                <div className={this.props.classes.collapse_icon} onClick={this.onCollapse}>
                  <Icon type={this.state.collapsed ? "menu-unfold" : "menu-fold"} />
                </div>
                {!this.state.collapsed &&
                  <div style={{
                    margin: 0, fontSize: 24,
                    textAlign: "left",
                    fontWeight: "lighter",
                    paddingLeft: 16,
                    paddingBottom: "0.25em",
                    textOverflow: "ellipsis",
                    // whiteSpace: "nowrap",
                    color: "white"
                  }}>{this.state.title}</div>
                }
              </div>
              {
                <div style={{ width: "100%", display: 'flex', borderBottomStyle: 'outset', borderBottomColor: 'rgba(255, 255, 255, 0.25)' }}>
                  {!this.state.collapsed && !isMobile && [
                    <Icon key={0} className={this.props.classes.collapse_icon + " " + (!step ? " disabled" : null)}
                      type="arrow-left"
                      onClick={() => {
                        if (step)
                          this.changePage(step - 1);
                      }} />
                    ,
                    <Icon key={1}
                      className={this.props.classes.collapse_icon + " " + (step === this.state.pages.length - 1 && "disabled")}
                      type="arrow-right"
                      onClick={() => {
                        if (step !== this.state.pages.length - 1)
                          this.changePage(step + 1);
                      }} />
                  ]
                  }
                  <Link style={{ color: 'white' }} to="/" onClick={() => {
                    document.title = site_course.toUpperCase()
                  }}>
                    <Icon
                      className={this.props.classes.collapse_icon}
                      type="home" />
                  </Link>
                </div>
              }
              <Scrollbars ref='steps_scrollbar' style={{ flex: 1 }} autoHide>
                <Steps direction="vertical" current={step}>
                  {this.state.pages.map((page, i) => {
                    return <Step key={i} onClick={() => {
                      this.changePage(i);
                    }} title={!this.state.collapsed && page.title} description={!this.state.collapsed && page.description}
                      style={{ cursor: "pointer" }} />
                  })}
                </Steps>
              </Scrollbars>
            </div>
          }
        </Sider>
        {this.state.pages &&
          <Layout style={{
            minWidth: isMobile && "calc(100vw - 48px)",
            display: 'flex',
            flexFlow: 'column',
            alignItems: 'center',
            background: 'white',
            maxHeight: '100%',
            boxShadow: "0 6px 12px rgba(0,0,0,0.7)",
            zIndex: 2,
            transition: "all 0.3s"
          }}
            className={this.state.pages[step].landing && this.props.classes.landing}>
            <Scrollbars style={{ height: '100%' }} ref="page_scrollbar">
              <div style={{
                minHeight: '100%',
                width: '100%',
                maxWidth: '100%',
                display: 'flex',
                justifyContent: 'space-between',
              }}>
                <div style={{ visibility: step === 0 && 'hidden', display: isMobile && 'none' }}
                  className={this.props.classes.page_button_container} onClick={
                    () => this.changePage(step - 1)
                  }>
                  <Icon type="left" style={{ position: 'fixed' }} />
                </div>
                {this.state.pages[step].md ?
                  <Content className={this.props.classes.content}
                    style={{ textAlign: 'left', flex: '0 1 1024px' }}
                  >
                    {Parser(this.state.html[step] || '', {
                      replace: (domNode) => {
                        if (domNode.name === "definition") {
                          return <Alert className="definition" message={
                            <div dangerouslySetInnerHTML={{ __html: mdk.render(domNode.attribs.title) }} />} description={
                              <div dangerouslySetInnerHTML={{ __html: mdk.render(domNode.attribs.description) }} />}
                            type="info" />
                        } else if (domNode.name === "titanium") {
                          return <Titanium />
                        } else if (domNode.name === "svg") {
                          return <SVG src={domNode.attribs.src} style={domNode.attribs.style}
                            width={domNode.attribs.width || 1} height={domNode.attribs.height || 1} />;
                        } else if (domNode.name === "animation") {
                          return <Animation id={domNode.attribs.id} src={domNode.attribs.src} isMobile={isMobile}
                            style={domNode.attribs.style} height={domNode.attribs.height}
                            width={domNode.attribs.width} padding={domNode.attribs.padding}
                            thumbnailFrame={domNode.attribs.thumbnailframe || 1} />
                        } else if (domNode.name === 'iframe') {
                          if (!['video', 'animation'].includes(domNode.attribs.type)) {
                            return <IFrame
                              src={domNode.attribs.src + '?zid=' + encodeURI(crypter.decrypt(localStorage.getItem('zid'))) + '&courseid=' + encodeURI(crypter.decrypt(localStorage.getItem('courseid'))) + '&name=' + encodeURI(crypter.decrypt(localStorage.getItem('name')))}
                              height={domNode.attribs.height} />
                          }
                        } else if (domNode.name === 'molecule') {
                          return <br />
                        } else if (domNode.name === "phaseswitcher") {
                          return <PhaseSwitcher detail={domNode.attribs.detail} left={domNode.attribs.left} />
                        }
                      }
                    })}
                  </Content>
                  :
                  this.state.pages[step].title === "Glossary" ?
                    <Content
                      className={this.props.classes.content}
                      style={{ textAlign: 'left', flex: '0 1 1024px' }}>
                      <h1>Glossary</h1>
                      {
                        <Table className="glossary" dataSource={glossary} pagination={false}
                          columns={[{
                            title: 'Term',
                            dataIndex: 'term',
                            key: 'term',
                            width: 200,
                            render: (text, record, index) => <span
                              style={{ color: record.curr ? '#2f54eb' : 'black', fontWeight: 'bolder' }} dangerouslySetInnerHTML={{ __html: mdk.render(text) }}></span>
                          }, { title: 'Definition', dataIndex: 'definition', key: 'definition', render: (text) => <span dangerouslySetInnerHTML={{ __html: mdk.render(text) }}></span> }]} />
                      }
                    </Content>
                    :
                    <Content
                      className={this.props.classes.content}
                      style={{ textAlign: 'left', flex: '0 1 1024px' }}
                      dangerouslySetInnerHTML={{ __html: this.state.html[step] }} />
                }
                <div style={{ visibility: step === this.state.pages.length - 1 && 'hidden', display: isMobile && 'none' }}
                  className={this.props.classes.page_button_container} onClick={
                    () => this.changePage(step + 1)
                  }>
                  <Icon type="right" style={{ position: 'fixed' }} />
                </div>
              </div>
            </Scrollbars>
            <Footer style={{
              width: "100%",
              bottom: 0,
              height: 48,
              padding: 0,
              position: 'sticky',
              display: isMobile ? 'flex' : 'none',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
              <Button shape="circle" type="default" disabled={!step} onClick={() => {
                this.changePage(step - 1);
              }}>
                <Icon type="left" />
              </Button>
              <span
                style={{ width: "calc(100vw - 128px)" }}>{this.state.pages[step].title}</span>
              <Button shape="circle" type="default" disabled={step === this.state.pages.length - 1}
                onClick={() => {
                  this.changePage(step + 1);
                }}>
                <Icon type="right" />
              </Button>
            </Footer>
          </Layout>
        }
      </Layout>
    )
  }

}

const styles = {
  landing: {
    backgroundColor: 'rgba(0,0,0,0.5) !important',
    color: 'white !important',
    '& h1, h2': {
      color: 'white !important'
    },
    '& .ant-layout-content': {
      display: 'flex',
      flexFlow: 'column',
      justifyContent: 'center',
      padding: '2vh 2vw !important',
    }
  },
  content: {
    padding: '5vh 2vw !important',
    display: 'flex',
    flexFlow: 'column',
    '@media (max-width: 480px)': {
      padding: '16px !important'
    }
  },
  page_button_container: {
    width: 64,
    maxHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '1 0 64px',
    fontSize: 48,
    transition: "font-size 0.3s ease",
    color: 'lightgrey',
    '&:hover': {
      fontSize: 48,
      color: 'grey'
    },
    '&:active': {
      fontSize: 36,
      color: 'grey'
    }
  },
  collapse_icon: {
    fontSize: 24,
    width: 48,
    height: 48,
    padding: 12,
    cursor: "pointer",
    transition: "color .3s",
    border: "1px solid rgba(255, 255, 255, 0)",
    "&.disabled": {
      color: "rgba(255, 255, 255, 0.3)"
    },
    "&:not(.disabled):hover": {
      background: "rgba(255, 255, 255, 0.2)",
      border: "1px solid rgba(255, 255, 255, 0.5)"
    },
    "&:not(.disabled):active": {
      background: "transparent"
    }
  }
};

export default injectSheet(styles)(App);



// WEBPACK FOOTER //
// ./src/App.js